import { createSlice } from "@reduxjs/toolkit"


const initialState = {
    isOpen:false,
    tokenInput:false,
    recentSearch:[],
    searchResults:null,
    loadingSearch:false,
    errorSearch:false,
    searchQuery:null
    
}




export const searchTokenSlice = createSlice({
    name:'search',
    initialState:initialState,
    reducers: {
        setRecentSearch: (state, action) => {
            state.recentSearch =[...state?.recentSearch, action.payload]
        },
        setSearchResults: (state, action) => {
            state.searchResults =action.payload
        },
        
        setLoadingSearch: (state, action) => {
            state.loadingSearch = action.payload
        },
        setErrorSearch: (state, action) => {
            state.errorSearch = action.payload
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload
        },

      }

})


export const {setRecentSearch,setSearchResults,setLoadingSearch,setErrorSearch , setSearchQuery} = searchTokenSlice.actions
export const selectRecentSearch = (state, address) => state.search.recentSearch
export const selectSearchResults= (state, address) => state.search.searchResults
export const selectSearchQuery= (state, address) => state.search.searchQuery

export const selectLodingSearch= (state, address) => state.search.loadingSearch
export const selectErrorSearch= (state, address) => state.search.errorSearch